import React from "react"
import { DocumentList } from "src/features/documents/components/DocumentList"
import { CATEGORY_GROUPS } from "src/features/documents/constants"

// Thin wrapper kept for the lead detail page. The generic DocumentList now owns
// upload/list/delete; lead documents default to the transaction category group
// plus KYC (Aadhaar/PAN), which is the common lead-stage paperwork.
export function LeadDocuments({ leadId }) {
  return (
    <DocumentList
      scope={{ type: "lead", id: leadId }}
      categories={["kyc", ...CATEGORY_GROUPS.transaction]}
      emptyHint="No documents attached to this lead"
    />
  )
}
